/* Circ — product info column behaviour.
   Tie an app block (e.g. the Nutrition Facts widget) to the collapsible row
   directly above it: the block is hidden until that accordion is opened, and
   hidden again when it closes. No hardcoded block names — any .shopify-app-block
   whose previous sibling is a Circ accordion is bound, so it survives reorders. */
(function () {
  function bindAccordionApps(root) {
    var appBlocks = root.querySelectorAll('.product__info-container .shopify-app-block');
    appBlocks.forEach(function (appBlock) {
      var prev = appBlock.previousElementSibling;
      if (!prev || !prev.classList.contains('product__accordion')) return;
      var details = prev.querySelector('details');
      if (!details) return;

      var sync = function () {
        appBlock.hidden = !details.open;
      };
      details.open = true; // start open so the app block shows on load
      sync();
      details.addEventListener('toggle', sync);
    });
  }

  if (document.readyState !== 'loading') {
    bindAccordionApps(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      bindAccordionApps(document);
    });
  }
})();
